import { render } from "./Methodology.vue?vue&type=template&id=0001310b"
import script from "./Methodology.vue?vue&type=script&lang=js"
export * from "./Methodology.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__